import { useParams,useNavigate } from "react-router-dom"
import { useState,useEffect } from "react"
import { Container } from "@mui/material"

import BlogForm from "./BlogForm"
import { baseURL } from "../../Config/config";
import Navbar from "../CommonC/SelexSolNavbar";
import BgContainer2 from "../CommonC/BgContainer2";



function AdminEditBlog(){

const {blog_id} = useParams()

const navigate = useNavigate()


const [blog, setBlog] = useState({
  title: "",
  slug: "",
  description: "",
  author: "",
  image: "",
  content: "",
});
console.log(blog_id)
console.log(blog)



const editBlog = async ()=>{
  const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(blog),
      };
      try {
        let res = await fetch(`${baseURL}/editblog`, requestOptions);
        res = await res.json();
        if (res.code) {
          navigate("/adminhome")
          return;
        }
        alert("Some Error");
      } catch (error) {
        alert("Some Error", error);
        console.log("err", error);
      }

}
useEffect(() => {
  getAllBlogs();
}, [blog_id]);

const getAllBlogs = async () => {
  try {
    let result = await fetch(`${baseURL}/getallblogs`);
    result = await result.json();

    if (result.code) {
      const allBlogs = result.data;

      // find selected blog
      const selectedBlog = allBlogs.find(
        (b) => String(b.blog_id) === String(blog_id)
      );

      // set state
      if (selectedBlog) {
        setBlog({
          title: selectedBlog.title || "",
          slug: selectedBlog.slug || "",
          description: selectedBlog.description || "",
          author: selectedBlog.author || "",
          date: selectedBlog.date || "",
          image: selectedBlog.image || "",
          content: selectedBlog.content || "",
          blog_id: selectedBlog.blog_id || "",
        });
      }

      return;
    }

    alert("There was some error");
  } catch (error) {
    console.log("error", error);
  }
};


return(

 <div
        style={{
          height:window.screen.height
        }}
      >
       
        <Navbar admin={true}/>
<Container sx={{background:"white", maxHeight: "750px",overflowY: "auto",marginTop:"15px",padding:"10px"}}>


<BlogForm
blog={blog}
setBlog={setBlog}
onSubmit={editBlog}
editStatus = {true}
/>

</Container>
</div>

)

}

export default AdminEditBlog